import { addActionErrorChatItem } from './chatActions';
import { addTextHistoryEntry } from './historyActions';
import { hideLobbyPrizeWin, showLobbyPrizeWinFromInbound } from './lobbyActions';
import { addMessageBox } from './messageBoxesActions';
import { hideMttStagingPrizeWin, showMttStagingPrizeWinFromInbound } from './mttStagingActions';
import { hidePokerRoomPrizeWin, showPokerRoomPrizeWinFromInbound } from './pokerActions';
import { updateFreeDailyBonusDelay } from './selfDataActions';
export const CLEAR_COMMON_STATE = 'CLEAR_COMMON_STATE';
export const SET_IS_KEYBOARD_CAPTURING_INPUT_ACTIVE = 'SET_IS_KEYBOARD_CAPTURING_INPUT_ACTIVE';
export const SHOW_REBUY_WINDOW_FROM_INBOUND = 'SHOW_REBUY_WINDOW_FROM_INBOUND';
export const CLEAR_REBUY_WINDOW = 'CLEAR_REBUY_WINDOW';
export const SET_NEXT_TOURNEY_FROM_INBOUND = 'SET_NEXT_TOURNEY_FROM_INBOUND';
export const ADD_ACTION_ERROR_FROM_INBOUND = 'ADD_ACTION_ERROR_FROM_INBOUND';
export const SET_IS_COLUMN_LAYOUT_MODE = 'SET_IS_COLUMN_LAYOUT_MODE';
export function setIsKeyboardCapturingInputActive(isKeyboardCapturingInputActive) {
    return {
        type: SET_IS_KEYBOARD_CAPTURING_INPUT_ACTIVE,
        payload: isKeyboardCapturingInputActive
    };
}
export function clearCommonState() {
    return {
        type: CLEAR_COMMON_STATE
    };
}
export function showRebuyWindowFromInbound(inbound) {
    return {
        type: SHOW_REBUY_WINDOW_FROM_INBOUND,
        payload: inbound
    };
}
export function clearRebuyWindow() {
    return {
        type: CLEAR_REBUY_WINDOW
    };
}
export function setNextTourneyFromInbound(inbound) {
    return {
        type: SET_NEXT_TOURNEY_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkAddActionErrorFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        // check if chat panel is visible and not obscured by a message box / modal:
        const isChatVisible = state.panels.activePanelType === 'chat' && state.messageBoxes.messageBoxes.length === 0;
        if (isChatVisible) {
            dispatch(addActionErrorChatItem(inbound.message));
        }
        else {
            // error should be shown on a new message box in front to be obvious
            dispatch(addMessageBox({ type: 'basic', title: 'Error', message: inbound.message }));
        }
    };
}
export function thunkShowPrizeWinFromInbound(inbound) {
    return function (dispatch, getState) {
        const roomSceneType = getState().scene.roomSceneType;
        switch (roomSceneType) {
            case 'lobby': {
                dispatch(showLobbyPrizeWinFromInbound(inbound));
                break;
            }
            case 'mttStaging': {
                dispatch(showMttStagingPrizeWinFromInbound(inbound));
                break;
            }
            case 'poker': {
                dispatch(showPokerRoomPrizeWinFromInbound(inbound));
                dispatch(addTextHistoryEntry('Prize Won', 'sub'));
                const prizeWonText = [inbound.messageToOthers, inbound.prizeDescription].join(' ').trim();
                dispatch(addTextHistoryEntry(prizeWonText));
                break;
            }
        }
    };
}
export function thunkHidePrizeWin() {
    return function (dispatch) {
        // should be safe to just hide in all scenes even if not active:
        dispatch(hideLobbyPrizeWin());
        dispatch(hideMttStagingPrizeWin());
        dispatch(hidePokerRoomPrizeWin());
    };
}
export function thunkFreeDailyBonusSuccessFromInbound(inbound) {
    return function (dispatch) {
        const { freeDailyBonusSecondsLeft, numBaseChips, numActivityChips, numStreakChips, powerPlayerAdditionalPercent, numTotalChips, streak } = inbound;
        dispatch(updateFreeDailyBonusDelay(freeDailyBonusSecondsLeft));
        dispatch(addMessageBox({
            type: 'free-daily-bonus-success',
            numBaseChips,
            numActivityChips,
            numStreakChips,
            powerPlayerAdditionalPercent,
            numTotalChips,
            streak
        }));
    };
}
export function setIsColumnLayoutMode(isColumnLayoutMode) {
    return {
        type: SET_IS_COLUMN_LAYOUT_MODE,
        payload: isColumnLayoutMode
    };
}
